/**
 * Build an element
 * @param tag Tag name of the element, will be passed to `createElement`, required
 * @param options Attributes of the elements, optional
 * @param children Child elements or strings, optional
 */
export function eli(tag, options, children) {
    const element = document.createElement(tag);
    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (key === 'style') {
                for (const [styleKey, styleValue] of Object.entries(value)) {
                    element.style[styleKey] = styleValue;
                }
            }
            else if (key === 'dataset') {
                for (const [dataKey, dataValue] of Object.entries(value)) {
                    element.dataset[dataKey] = dataValue;
                }
            }
            else {
                element[key] = value;
            }
        }
    }
    if (children)
        element.append(...children);
    return element;
}
